// extracted by mini-css-extract-plugin
export var header = "_aw-0";